import React from 'react';
import Icon from './Icon';

const Pairings = ({ round, players, onUpdatePairing, onCompleteRound, onBack, onRegeneratePairings }) => {
  const getPlayerName = (id) => players.find(p => p.id === id)?.name || 'BYE';

  const updateResult = (pairingId, p1Wins, p2Wins, draws) => {
    onUpdatePairing(pairingId, p1Wins, p2Wins, draws);
  };

  // Vérification de sécurité pour éviter l'erreur
  if (!round || !round.pairings) {
    return (
      <div className="min-h-screen p-4">
        <button onClick={onBack} className="mb-4 text-red-500 flex items-center gap-2">
          <Icon d="M15 19l-7-7 7-7" />
          Retour
        </button>
        <div className="text-center text-gray-400 mt-8">
          <p>Erreur : Round non trouvé</p>
        </div>
      </div>
    );
  }

  const allCompleted = round.pairings.every(p => p.completed);

  return (
    <div className="min-h-screen p-4">
      <button onClick={onBack} className="mb-4 text-red-500 flex items-center gap-2">
        <Icon d="M15 19l-7-7 7-7" />
        Retour
      </button>

      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Round {round.number}</h1>
        <div className="flex items-center gap-4">
          <span className="text-sm text-gray-400">
            {round.pairings.filter(p => p.completed).length}/{round.pairings.length}
          </span>
          {onRegeneratePairings && (
            <button
              onClick={onRegeneratePairings}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg font-semibold text-sm flex items-center gap-2 hover:bg-blue-700 transition"
            >
              <Icon d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" className="w-4 h-4" />
              Refaire
            </button>
          )}
        </div>
      </div>

      <div className="space-y-3 mb-20">
        {round.pairings.map(pairing => (
          <div key={pairing.id} className="bg-gray-800 rounded-lg p-4">
            <div className="flex items-center justify-between mb-3">
              <div className="flex-1">
                <div className="font-semibold">{getPlayerName(pairing.player1Id)}</div>
              </div>
              <div className="text-2xl font-bold text-gray-500 mx-4">VS</div>
              <div className="flex-1 text-right">
                <div className="font-semibold">{getPlayerName(pairing.player2Id)}</div>
              </div>
            </div>

            {!pairing.player2Id ? (
              <div className="text-center text-green-400 text-sm">BYE - Victoire automatique</div>
            ) : (
              <div className="grid grid-cols-3 gap-2">
                <button
                  onClick={() => updateResult(pairing.id, 1, 0, 0)}
                  className={`py-3 rounded-lg font-semibold transition ${
                    pairing.player1Wins === 1 && pairing.player2Wins === 0 && pairing.draws === 0
                      ? 'bg-green-600 text-white' 
                      : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                  }`}
                >
                  {getPlayerName(pairing.player1Id)} gagne
                </button>
                <button
                  onClick={() => updateResult(pairing.id, 0, 0, 1)}
                  className={`py-3 rounded-lg font-semibold transition ${
                    pairing.draws === 1
                      ? 'bg-yellow-600 text-white' 
                      : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                  }`}
                >
                  Égalité
                </button>
                <button
                  onClick={() => updateResult(pairing.id, 0, 1, 0)}
                  className={`py-3 rounded-lg font-semibold transition ${
                    pairing.player1Wins === 0 && pairing.player2Wins === 1 && pairing.draws === 0
                      ? 'bg-green-600 text-white' 
                      : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                  }`}
                >
                  {getPlayerName(pairing.player2Id)} gagne
                </button>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="fixed bottom-0 left-0 right-0 p-4 bg-gray-900 border-t border-gray-800">
        <button
          onClick={onCompleteRound}
          disabled={!allCompleted}
          className="w-full bg-red-600 text-white py-4 rounded-lg font-semibold disabled:bg-gray-700 disabled:text-gray-500"
        >
          Terminer le round
        </button>
      </div>
    </div>
  );
};

export default Pairings;